import styled from "@emotion/styled";
import Colors from "/styles/colors";
const BASIC_IMAGE_RATIO = 1423 / 824; // based on the size of our thumbnail image design guidelines
const MAIN_GALLERY_HEIGHT = 430;
const MAIN_GALLERY_WIDTH = Math.floor(MAIN_GALLERY_HEIGHT * BASIC_IMAGE_RATIO);
export const StyledAssetGallery = styled.div`
  .asset-gallery {
    display: flex;
    height: ${MAIN_GALLERY_HEIGHT}px;

    .main-asset-wrapper {
      height: 100%;
      width: ${MAIN_GALLERY_WIDTH}px;

      padding: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      background: ${Colors["riverstone"]};
      border-radius: 4px;
      flex-grow: 1;

      .main-asset {
        height: 100%;
        max-width: 100%;
      }
    }

    .assets-previews-wrapper {
      position: relative;
      margin-left: 16px;
      .previews-container {
        display: flex;
        flex-direction: column;
        overflow: auto;
        height: 100%;

        &::-webkit-scrollbar {
          width: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background-color: ${Colors["silver"]};
          border-radius: 4px;
        }

        .preview-asset-wrapper {
          position: relative;
          padding: 8px;
          border: 2px solid transparent;

          background: ${Colors["riverstone"]};
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          border-radius: 4px;

          &.selected {
            border: 2px solid #4353ff;
            box-sizing: border-box;
          }

          &:not(:last-child) {
            margin-bottom: 8px;
          }
          .preview-asset {
            width: 160px;
            height: 90px;
            object-fit: contain;
          }

          .video-thumbnail-icon {
            position: absolute;
            bottom: 2px;
            left: 2px;
            height: 20px;
            width: 20px;
          }
        }
      }

      .preview-side-images-bottom-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        min-height: 80px;
        pointer-events: none;
        background: linear-gradient(180deg, rgba(white, 0) 0%, rgba(white, 1) 100%);
        background: linear-gradient(180deg, rgba(white, 0) 0%, rgba(white, 1) 100%);
      }
    }
  }
`;
